import { render } from "./OffersEdit.vue?vue&type=template&id=f037ad1c"
import script from "./OffersEdit.vue?vue&type=script&lang=js"
export * from "./OffersEdit.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__